export const msaByAlias = (msas, alias) => (msas || []).filter(msa => msa.alias === alias)[0];
export const msaById = (msas, id) => (msas || []).filter(msa => msa.id === id)[0];
export const msaByIdentifier = (msas, identifier) =>
  typeof identifier === 'number'
    ? msaById(msas, identifier)
    : msaByAlias(msas, identifier) || msaById(msas, parseInt(identifier, 10));
